import React from 'react';
import PropTypes from 'prop-types';

import {
  ALTERNATE_SOURCE_STATUS,
  ALTERNATE_SOURCE_STATUS_CONFIG,
} from './constants';

import './_booksMapping.scss';

export const AlternateSource = ({
  alternateSourceId,
  status = ALTERNATE_SOURCE_STATUS.UNSET,
}) => {
  const alternateSourceConfig = ALTERNATE_SOURCE_STATUS_CONFIG[status];

  return (
    <div className="knock-react-flex input-auto">
      <div className="property-info-edit-field-label">Alternate SourceId</div>
      <div
        className="property-info-edit-field-label icon-container"
      >
        <i
          className={alternateSourceConfig.iconClassName}
          style={{ color: alternateSourceConfig.iconColor }}
          title={alternateSourceConfig.iconTitle}
        />
        <span>{alternateSourceId || 'Unknown'}</span>
      </div>
    </div>
  );
};

AlternateSource.propTypes = {
  alternateSourceId: PropTypes.string,
  status: PropTypes.string,
};
